/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Import reference sketch</h4>

<p>Import a .jpg, .png or .gif file to use as reference.</p>`;

export default function LoadSketchesTooltip() {
    return h('div', { innerHTML: body });
}
